import script from "./GamePanelView.vue?vue&type=script&lang=ts&setup=true"
export * from "./GamePanelView.vue?vue&type=script&lang=ts&setup=true"

import "./GamePanelView.vue?vue&type=style&index=0&id=e331d67c&lang=scss"

const __exports__ = script;

export default __exports__